import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import PositionsPopupsDetails from "../../../Positions/Positions-Popups/PositionsPopupsDetails";
import Button from "../../../Helpers/Button/Button";
import trans from "../../../../utils";
import POIsPopup from "../../POIsPopup/POIsPopup";
import { popupcontext } from "../../../../context/Popupscontext";

export default function POIsPositionBodyPopups({ data, setMapId }) {
	const [geoCode, setGeoCode] = useState(false);
	let { currentPOIId, setcurrentPOIId } = useContext(popupcontext);
	const fetchGeoCodePosition = async () => {
		try {
			const response = await axios.get(
				`https://nominatim.openstreetmap.org/reverse.php?lat=${data?.latitude}&lon=${data?.longitude}&zoom=18&format=jsonv2`
			);
			setGeoCode(`${response.data.display_name}`);
			return `${response.data.display_name}`;
		} catch (error) {
			console.error("Error fetching geocode position:", error);
		}
	};
	useEffect(() => {
		fetchGeoCodePosition(23.8859, 45.0792);
	}, []);
	return (
		<div className="device-popup-body position-relative">
			<PositionsPopupsDetails img="Anchor" item={geoCode} truncate={true} />
			<PositionsPopupsDetails img="Retail" item={data?.type} truncate={true} />
			<PositionsPopupsDetails
				img="POIGeofence"
				item="500m radius"
				truncate={true}
			/>
			<Button
				type="default"
				htmlType="button"
				style={{
					bottom: "10px",
					maxWidth: "285px",
					width: "100%",
				}}
				className="text-center w-100"
				onClick={() => setcurrentPOIId(data?.id)}
				text={trans("View Details")}
			/>
			{data?.id === currentPOIId && <POIsPopup poiId={currentPOIId} />}
		</div>
	);
}
